import React from 'react';
import { Card, CardContent, Badge, Button } from '@ncoder/ui';
import { GitBranch, GitMerge, GitPullRequest, CheckCircle } from 'lucide-react';

export interface BranchData {
  name: string;
  isDefault: boolean;
  lastCommit: string;
  author: string;
  commits: number;
  status: 'active' | 'merged' | 'stale';
}

interface BranchCardProps {
  branch: BranchData;
  onSwitch?: (branchName: string) => void;
  onMerge?: (branchName: string) => void;
  onCreatePR?: (branchName: string) => void;
}

export const BranchCard: React.FC<BranchCardProps> = ({
  branch,
  onSwitch,
  onMerge,
  onCreatePR,
}) => {
  return (
    <Card>
      <CardContent className="p-4">
        <div className="flex items-center justify-between">
          <div className="flex items-center gap-3">
            <GitBranch className="h-5 w-5 text-muted-foreground" />
            <div>
              <div className="flex items-center gap-2">
                <span className="font-medium">{branch.name}</span>
                {branch.isDefault && (
                  <Badge variant="default" className="text-xs">Default</Badge>
                )}
                {branch.status === 'merged' && (
                  <Badge variant="secondary" className="text-xs">
                    <CheckCircle className="h-3 w-3 mr-1" />
                    Merged
                  </Badge>
                )}
              </div>
              <p className="text-sm text-muted-foreground">
                {branch.commits} commits • Last updated {branch.lastCommit} by {branch.author}
              </p>
            </div>
          </div>
          <div className="flex items-center gap-2">
            {branch.status === 'active' && (
              <>
                {onSwitch && (
                  <Button variant="outline" size="sm" onClick={() => onSwitch(branch.name)}>
                    Switch
                  </Button>
                )}
                {onCreatePR && (
                  <Button variant="outline" size="sm" onClick={() => onCreatePR(branch.name)}>
                    <GitPullRequest className="h-4 w-4 mr-1" />
                    PR
                  </Button>
                )}
                {!branch.isDefault && onMerge && (
                  <Button variant="outline" size="sm" onClick={() => onMerge(branch.name)}>
                    <GitMerge className="h-4 w-4 mr-1" />
                    Merge
                  </Button>
                )}
              </>
            )}
          </div>
        </div>
      </CardContent>
    </Card>
  );
};
